export const API_CONFIG = {
  baseURL: import.meta.env.VITE_API_BASE_URL,
  apiKey: import.meta.env.VITE_API_KEY,
  hmacSecret: import.meta.env.VITE_HMAC_SECRET,
};
